import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 inline" }
const _hoisted_2 = { class: "tooltip-text" }

import { computed, onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipText',
  props: {
    tooltipText: null,
    labelText: null
  },
  setup(__props: any) {



const tooltipId = ref();

const isTouch = computed(() => 'ontouchstart' in window || navigator.maxTouchPoints);

const toggleTooltip = event => {
  if (isTouch.value) tooltipId.value.toggle(event);
};
const showTooltip = event => {
  if (!isTouch.value) tooltipId.value.show(event);
};
const hideTooltip = () => {
  tooltipId.value.hide();
};

onMounted(() => {
  if (isTouch.value) {
    document.addEventListener('scroll', hideTooltip);
  }
});
onUnmounted(() => {
  if (isTouch.value) {
    document.removeEventListener('scroll', hideTooltip);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, _mergeProps(_ctx.$attrs, {
        class: "border-none button-plain line-height-1",
        onClick: toggleTooltip,
        onMouseenter: showTooltip,
        onMouseleave: hideTooltip,
        "aria:haspopup": "true",
        "aria-controls": "overlay_panel",
        label: __props.labelText
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "labelText")
        ]),
        _: 3
      }, 16, ["label"])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "tooltipId",
      ref: tooltipId,
      appendTo: "body",
      showCloseIcon: false,
      id: "tooltip_panel",
      class: "tooltip px-s3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "tooltipText", {}, () => [
            _createTextVNode(_toDisplayString(__props.tooltipText), 1)
          ])
        ])
      ]),
      _: 3
    }, 512)
  ], 64))
}
}

})